import { render, staticRenderFns } from "./AdminUserDetail.vue?vue&type=template&id=2af74159&scoped=true&"
import script from "./AdminUserDetail.vue?vue&type=script&lang=js&"
export * from "./AdminUserDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdminUserDetail.vue?vue&type=style&index=0&id=2af74159&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af74159",
  null
  
)

export default component.exports